module.exports = __webpack_public_path__ + "static/media/amex.232403f5.png";